import React from "react"
import PropTypes from "prop-types"
import HubPurple from "../mapAssets/hub-purple.png"
import HubOrange from "../mapAssets/hub-orange.png"
import HubTeal from "../mapAssets/hub-teal.png"
import HubYellow from "../mapAssets/hub-yellow.png"

import {
  StyledContainer,
  StyledContentContainer,
  StyledName,
  StyledTime,
  StyledTraffic,
  StyledFirstLine,
  StyledIcon,
} from "./KeyPointInfoLabel.styles"

const pins = {
  orange: HubOrange,
  teal: HubTeal,
  yellow: HubYellow,
  purple: HubPurple,
}

const KeyPointInfoLabel = ({ aproxTime, name, trafficThroughput, colors }) => {
  return (
    <StyledContainer>
      <StyledIcon src={pins[colors.name]} />

      <StyledContentContainer>
        <StyledFirstLine>
          <StyledName>{name}</StyledName>
          {aproxTime && <StyledTime>({aproxTime})</StyledTime>}
        </StyledFirstLine>

        <StyledTraffic>{trafficThroughput}</StyledTraffic>
      </StyledContentContainer>
    </StyledContainer>
  )
}

KeyPointInfoLabel.propTypes = {
  aproxTime: PropTypes.string,
  name: PropTypes.string,
  trafficThroughput: PropTypes.string,
  colors: PropTypes.shape({
    name: PropTypes.string,
    body: PropTypes.string,
    border: PropTypes.string,
  }).isRequired,
}
KeyPointInfoLabel.defaultProps = {
  aproxTime: null,
  name: null,
  trafficThroughput: null,
}
export default KeyPointInfoLabel
